<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
    <span>{{ params.value }}</span>
  </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  methods: {
    chipColor(value) {
      if (value === 'N/A') return 'white'
      if (value === 'Paid (Cash/POS)') return 'success'
      if (value.startsWith('Transaction')) return 'success'
      if (value === 'Paid') return 'success'
      if (value === 'Not Paid') return 'danger'
      if (value === 'false') return 'warning'
      if (value === 'FACTURA PRIMITA') return 'warning'
      if (value === 'NOT PROCESSED') return 'danger'
      else if (value === false) return 'danger'
      else 
      {
        
      }
    }
  }
}
</script>
